module.exports = __webpack_public_path__ + "img/information_ethical@2x.906b1e2.webp";